<script>
export default {
  name: 'ExcelLogoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.6 4.1001V6.3001C20.6 7.1001 20.1 8.1001 19.6 8.6001L15.3 12.4001C14.7 12.9001 14.3 13.9001 14.3 14.7001V19.0001C14.3 19.6001 13.9 20.4001 13.4 20.7001L12 21.6001C10.7 22.4001 8.90001 21.5001 8.90001 19.9001V14.6001C8.90001 13.9001 8.50001 13.0001 8.10001 12.5001L7.63001 12.0101C7.32001 11.6801 7.26001 11.1801 7.51001 10.7901L12.63 2.5701C12.81 2.2801 13.13 2.1001 13.48 2.1001H18.6C19.7 2.1001 20.6 3.0001 20.6 4.1001Z"
      :fill="color"
    />
    <path
      d="M10.35 3.6301L6.80002 9.3201C6.46002 9.8701 5.68002 9.9501 5.23002 9.4801L4.30002 8.5001C3.80002 8.0001 3.40002 7.1001 3.40002 6.5001V4.2001C3.40002 3.0001 4.30002 2.1001 5.40002 2.1001H9.50002C10.28 2.1001 10.76 2.9601 10.35 3.6301Z"
      :fill="color"
    />
  </svg>
</template>
